import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { erpConfig } from './servicePageConfigs';

const ServiceErp = () => <ServicePageTemplate {...erpConfig} />;

export default ServiceErp;
